import React from "react";
import AllSend from "../../Components/Tracking/AllSend";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const AllSendPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <AllSend date={query.date} />
    </React.Fragment>
  );
};

export default AllSendPage;
